import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Button } from "@shared/components/Button";
import { TextField } from "@shared/components/TextField";
import { setFeaturedDate } from "./articles.api";
import type { ArticleDetail } from "./types";

/** "Tampilkan pada": pins a published tip as Tip Hari Ini on one date (WIB). */
export function FeatureDate({ article, onChange }: { article: ArticleDetail; onChange: (a: ArticleDetail) => void }) {
  const [date, setDate] = useState(article.featuredOn ?? "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => setDate(article.featuredOn ?? ""), [article.featuredOn]);

  async function save(next: string | null) {
    setBusy(true);
    setError("");
    try {
      onChange(await setFeaturedDate(article.id, next));
      toast.success(next ? "Tanggal tampil disimpan" : "Tanggal tampil dihapus");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Gagal menyimpan tanggal");
    } finally {
      setBusy(false);
    }
  }

  return (
    <fieldset className="card feature">
      <legend>Tip Hari Ini</legend>
      <TextField
        label="Tampilkan pada"
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        hint="Tip ini menjadi Tip Hari Ini pada tanggal tersebut (WIB). Satu tanggal untuk satu tip."
      />
      {error && (
        <p role="alert" className="form-error">
          {error}
        </p>
      )}
      <div className="row">
        <Button variant="secondary" disabled={busy || !date} onClick={() => void save(date)}>
          Simpan tanggal
        </Button>
        <Button variant="secondary" disabled={busy || !article.featuredOn} onClick={() => void save(null)}>
          Hapus tanggal
        </Button>
      </div>
    </fieldset>
  );
}
